import { memo, forwardRef } from 'react';
import * as React from 'react';

import {
    RadioButtonInput,
    RadioButtonLabel,
    RadioButtonActiveColors,
    RadioButtonActiveBackgroundColors
} from './RadioButton.styles';
import { ChangeHandler } from 'react-hook-form';

export type RadioButtonOnClick = (
    event: React.FormEvent<HTMLInputElement>
) => void;

export interface RadioButtonProps {
    id: string;
    value: string;
    label: string;
    name: string;
    onChange: ChangeHandler;
    onBlur: ChangeHandler;
    activeTextColor?: RadioButtonActiveColors;
    activeBackgroundColor?: RadioButtonActiveBackgroundColors;
    errorMessage?: string;
    onClick?: RadioButtonOnClick;
}

export const RadioButton = memo(
    forwardRef<HTMLInputElement, RadioButtonProps>(
        (
            {
                id,
                name,
                onChange,
                onBlur,
                label,
                activeTextColor = 'grey-slate',
                value,
                errorMessage,
                activeBackgroundColor = 'function-success',
                onClick
            },
            ref
        ) => (
            <>
                <RadioButtonInput
                    type="radio"
                    id={`${name}-${id}`}
                    data-testid={`input-${name}-${id}`}
                    name={name}
                    value={value}
                    ref={ref}
                    onClick={onClick}
                    activeTextColor={activeTextColor}
                    activeBackgroundColor={activeBackgroundColor}
                    onChange={onChange}
                    onBlur={onBlur}
                />
                <RadioButtonLabel
                    data-testid={`label-${name}-${id}`}
                    /*
                        Although we are wrapping the input, the htmlFor is maintained as some assistive technologies do not implicity apply the for attribute.
                        https://www.w3.org/TR/2008/WD-WCAG20-TECHS-20080430/H44.html
                    */
                    htmlFor={`${name}-${id}`}
                    errorMessage={errorMessage}
                >
                    {label}
                </RadioButtonLabel>
            </>
        )
    )
);
